export function getMapKeyByValue<K, V>(map: Map<K, V>, searchValue: V) {
  for (let [key, value] of map.entries()) {
    if (value === searchValue) return key;
  }
}
